import { takeEvery, fork, put, all, call } from 'redux-saga/effects';

import { customHeaders, adminAPIURL } from '../../../../../../Containers/Config/index.js';
import { LIST_RULES, LIST_RULES_SUCCESS, LIST_RULES_ERROR } from '../../../actions.js';
import apiCall from '../../../../apiCall.js';
import cogoToast from 'cogo-toast';

function* listRules({ payload }) {
  try {
    const filteredHeaders = { ...customHeaders };
    delete filteredHeaders['X-Requested-By'];

    const response = yield call(apiCall, {
      url: `${adminAPIURL}/v1/surge-campaign-rules`,
      method: 'GET',
      headers: {
        ...filteredHeaders,
      },
      params: payload?.urlParams,
    });

    if (response.status === 200) {
      yield put({
        type: LIST_RULES_SUCCESS,
        payload: response?.data,
      });
    } else {
      const message = response?.response?.data?.message || `Failed to load rules.`;
      cogoToast.error(message);
      yield put({
        type: LIST_RULES_ERROR,
        payload: message,
      });
    }
  } catch (error) {
    cogoToast.error(`Failed to load rules.`);
    yield put({ type: LIST_RULES_ERROR, payload: error });
  }
}

export function* watchlistRules() {
  yield takeEvery(LIST_RULES, listRules);
}

function* listRulesSaga() {
  yield all([fork(watchlistRules)]);
}

export default listRulesSaga;
